"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortStop = exports.AddressStop = exports.Stop = void 0;
const utils_1 = require("@loadsure/utils");
const _1 = require(".");
const countries_1 = require("../countries");
const address_1 = __importDefault(require("../address"));
const errors_1 = __importStar(require("../errors"));
class Stop {
    constructor(stopNumber, date) {
        this.stopNumber = stopNumber;
        this.date = date;
    }
    validate(path) {
        const errors = [];
        if (!this.stopType) {
            errors.push(new errors_1.default(errors_1.eErrorCode.STOP_TYPE_NOT_SET, `${path}.stopType`));
        }
        return errors;
    }
    getDate() {
        if (!this.date) {
            throw Error(`stop ${this.stopType} date not specified`);
        }
        return this.date;
    }
    static isStop(item) {
        return !!item;
    }
    static getStops(data, supportLegacy, partnerTimeZoneName, datePresentationFormat) {
        if (!Array.isArray(data) && !supportLegacy) {
            throw Error("stops must be a list");
        }
        const stops = Array.isArray(data)
            ? Stop.getStopsFromArray(data, partnerTimeZoneName, datePresentationFormat)
            : Stop.getStopsFromObject(data, partnerTimeZoneName, datePresentationFormat);
        const hasStopNumber = stops.every((stop) => stop.stopNumber != null);
        if (hasStopNumber) {
            stops.sort((a, b) => (a.stopNumber || 0) - (b.stopNumber || 0));
        }
        return stops;
    }
    static getStopsFromArray(stops = [], partnerTimeZoneName, datePresentationFormat) {
        return stops
            .map((stop) => Stop.fromObj(stop, undefined, partnerTimeZoneName, datePresentationFormat))
            .filter(Stop.isStop);
    }
    static fromObj(data, stopType, partnerTimeZoneName, datePresentationFormat) {
        const newStopType = stopType !== null && stopType !== void 0 ? stopType : data.stopType;
        const portStopType = PortStop.getStopType(newStopType);
        const addressStopType = AddressStop.getStopType(newStopType);
        if (portStopType) {
            return PortStop.fromObj(data, portStopType, partnerTimeZoneName, datePresentationFormat);
        }
        if (addressStopType) {
            return AddressStop.fromObj(data, addressStopType, partnerTimeZoneName, datePresentationFormat);
        }
        throw Error(`Unknown stop type ${newStopType}`);
    }
    static empty(stopType) {
        if (stopType === _1.ePortStopType.PORT_OF_LOADING ||
            stopType === _1.ePortStopType.PORT_OF_DISCHARGE) {
            return PortStop.empty(stopType);
        }
        return AddressStop.empty(stopType);
    }
    static getStopsFromObject(stopsObj = {}, partnerTimeZoneName, datePresentationFormat) {
        const sortedStops = Object.entries(stopsObj)
            .map(([name, stop]) => (Object.assign(Object.assign({}, stop), { address: Object.assign({}, stop.address), name })))
            .sort((stop1, stop2) => {
            if (stop1.date === stop2.date) {
                if (stop1.name < stop2.name) {
                    return -1;
                }
                if (stop1.name > stop2.name) {
                    return 1;
                }
                return 0;
            }
            return stop1.date < stop2.date ? -1 : 1;
        });
        let pickup;
        let delivery;
        const otherStops = [];
        sortedStops.forEach((stop) => {
            const type = stop.name.toUpperCase();
            if (type === "PICKUP") {
                pickup = stop;
            }
            else if (type === "DELIVERY") {
                delivery = stop;
            }
            else {
                otherStops.push(stop);
            }
        });
        if (!pickup && otherStops.length) {
            pickup = otherStops.shift();
        }
        if (!delivery && otherStops.length) {
            delivery = otherStops.pop();
        }
        const stops = [];
        if (pickup) {
            stops.push(AddressStop.fromObj(pickup, _1.eAddressStopType.PICKUP, partnerTimeZoneName, datePresentationFormat));
        }
        if (otherStops) {
            stops.push(...otherStops
                .map((stop) => AddressStop.fromObj(stop, _1.eAddressStopType.ADDITIONAL, partnerTimeZoneName, datePresentationFormat))
                .filter(Stop.isStop));
        }
        if (delivery) {
            stops.push(AddressStop.fromObj(delivery, _1.eAddressStopType.DELIVERY, partnerTimeZoneName, datePresentationFormat));
        }
        return stops;
    }
    getLocation() {
        var _a;
        if (this instanceof AddressStop) {
            if (this.address.country === "USA") {
                if (this.address.state === "HI") {
                    return "USA-HI";
                }
                return "USA-CNTL";
            }
        }
        else if ((this === null || this === void 0 ? void 0 : this.country) === "USA") {
            return "USA-CNTL";
        }
        return (_a = this === null || this === void 0 ? void 0 : this.country) !== null && _a !== void 0 ? _a : "";
    }
    get isOrigin() {
        return (this.stopType === _1.eAddressStopType.PICKUP ||
            this.stopType === _1.ePortStopType.PORT_OF_LOADING);
    }
}
exports.Stop = Stop;
class AddressStop extends Stop {
    constructor(stopType, address, stopNumber, date) {
        super(stopNumber, date);
        this.stopType = stopType;
        this.address = address;
    }
    static fromObj(data, stopType, partnerTimeZoneName, datePresentationFormat) {
        var _a;
        return new AddressStop((_a = stopType !== null && stopType !== void 0 ? stopType : AddressStop.getStopType(data.stopType)) !== null && _a !== void 0 ? _a : _1.eAddressStopType.ADDITIONAL, address_1.default.fromObj(data.address), data.stopNumber, data.date
            ? utils_1.parseDate(data.date, partnerTimeZoneName, datePresentationFormat)
            : data.date);
    }
    static empty(stopType) {
        return new AddressStop(stopType, address_1.default.empty());
    }
    validate(path) {
        const errors = [];
        errors.push(...super.validate(path));
        if (!this.address) {
            errors.push(new errors_1.default(errors_1.eErrorCode.ADDRESS_STOP_ADDRESS_NOT_SET, `${path}.address`));
        }
        else {
            errors.push(...this.address.validate(`${path}.address`, countries_1.postalRequired(this.address.country)));
        }
        return errors;
    }
    get country() {
        return this.address.country;
    }
    get state() {
        return this.address.state;
    }
    get displayName() {
        return this.address.shortAddress;
    }
    static get stopTypes() {
        return AddressStop.allStopTypes;
    }
    static getStopType(value) {
        return utils_1.getEnumKeyOrUndefined("stopType", _1.eAddressStopType, value === null || value === void 0 ? void 0 : value.toUpperCase());
    }
    static getStopTypeLabel(stopType) {
        return AddressStop.allStopTypes[stopType];
    }
}
exports.AddressStop = AddressStop;
AddressStop.allStopTypes = {
    [_1.eAddressStopType.PICKUP]: "Pickup",
    [_1.eAddressStopType.DELIVERY]: "Delivery",
    [_1.eAddressStopType.ADDITIONAL]: "Additional Stop"
};
class PortStop extends Stop {
    constructor(stopType, name, country, state, locode, stopNumber, date) {
        super(stopNumber, date);
        this.stopType = stopType;
        this.name = name;
        this.country = country;
        this.state = state;
        this.locode = locode;
    }
    static fromObj(data, stopType, partnerTimeZoneName, datePresentationFormat) {
        var _a, _b;
        return new PortStop((_a = stopType !== null && stopType !== void 0 ? stopType : PortStop.getStopType(data.stopType)) !== null && _a !== void 0 ? _a : "PORT_OF_LOADING", data.name, (_b = countries_1.getCountryCode(data.country)) !== null && _b !== void 0 ? _b : data.country, data.state, data.locode, data.stopNumber, data.date
            ? utils_1.parseDate(data.date, partnerTimeZoneName, datePresentationFormat)
            : data.date);
    }
    static empty(stopType) {
        return new PortStop(stopType, "", "", undefined);
    }
    validate(path) {
        const errors = [];
        errors.push(...super.validate(path));
        if (!this.name) {
            errors.push(new errors_1.default(errors_1.eErrorCode.PORT_STOP_NAME_NOT_SET, `${path}.name`));
        }
        if (!this.country) {
            errors.push(new errors_1.default(errors_1.eErrorCode.PORT_STOP_COUNTRY_NOT_SET, `${path}.country`));
        }
        return errors;
    }
    get displayName() {
        let name = `${this.name}, ${this.country}`;
        if (this.state) {
            name += `, ${this.state}`;
        }
        return name;
    }
    static get stopTypes() {
        return AddressStop.allStopTypes;
    }
    static getStopType(value) {
        return utils_1.getEnumKeyOrUndefined("stopType", _1.ePortStopType, value === null || value === void 0 ? void 0 : value.toUpperCase());
    }
    static getStopTypeLabel(stopType) {
        return PortStop.allStopTypes[stopType];
    }
}
exports.PortStop = PortStop;
PortStop.allStopTypes = {
    [_1.ePortStopType.PORT_OF_LOADING]: "Port of Loading",
    [_1.ePortStopType.PORT_OF_DISCHARGE]: "Port of Discharge"
};
//# sourceMappingURL=stop.class.js.map